//  Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { change } from 'redux-form'
import { EARTH_STATION_RESULTS_FORM } from 'redux/modules/interferenceAnalysis/constants'

const handleSelectAllEarthStationCasesChange = selectAll => (dispatch, getState) => {
  const { totalCaseNumbersCount } = getState().form[EARTH_STATION_RESULTS_FORM].values

  // if we're applying 'select all' right now, we want to set the caseNumbers text area
  // to be 1 : N, where N is the totalCaseNumbersCount
  // else we want to set it to an empty string (meaning user just deselected all cases
  const caseNumbers = selectAll ? `1:${totalCaseNumbersCount}` : ''

  dispatch(change(
    EARTH_STATION_RESULTS_FORM,
    'caseNumbers',
    caseNumbers
  ))

  dispatch(change(
    EARTH_STATION_RESULTS_FORM,
    'selectAll',
    selectAll
  ))
}

export default handleSelectAllEarthStationCasesChange
